import { useState } from 'react';
import { InboxStats } from '../models';
import { StatsPanelHeader } from './StatsPanelHeader';
import { StatsPanelGrid } from './StatsPanelGrid';

interface StatsPanelProps {
  stats: InboxStats;
}

export const StatsPanel = ({ stats }: StatsPanelProps) => {
  const [isExpanded, setIsExpanded] = useState(true);
  const sectors = Object.keys(stats);

  if (sectors.length === 0) {
    return null;
  }

  return (
    <div className='w-full flex flex-col gap-4 mt-6'>
      <StatsPanelHeader
        title='Indicadores del día'
        isExpanded={isExpanded}
        onToggle={() => setIsExpanded(!isExpanded)}
      />

      <div
        className={`grid transition-all duration-300 ease-in-out ${
          isExpanded
            ? 'grid-rows-[1fr] opacity-100'
            : 'grid-rows-[0fr] opacity-0 pointer-events-none'
        }`}
      >
        <div className='overflow-hidden'>
          <StatsPanelGrid stats={stats} sectors={sectors} />
        </div>
      </div>
    </div>
  );
};
